import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../../../slots/context.js';
import '@swc/helpers';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../../../types/product.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

const CLDeliveryIndicator = ()=>{
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    const { activeVariant  } = useProductData();
    const { state , selectors  } = useCLEcommContext();
    const { configurator , configurations , queries  } = state;
    const isOneColConfigurator = selectors.isOneColConfigurator(state);
    const isLoading = !!selectors.hasQueryLoading(state);
    const hasNonOrderableProduct = selectors.hasNonOrderableProduct(state);
    let deliveryItems = [];
    if (hasNonOrderableProduct) {
        deliveryItems = [];
    } else if (isOneColConfigurator) {
        if (queries.both.sku && configurator.both.isEnabled) {
            deliveryItems.push({
                sku: queries.both.sku,
                quantity: configurations.both.quantity
            });
        }
    } else {
        if (queries.left.sku && configurator.left.isEnabled) {
            deliveryItems.push({
                sku: queries.left.sku,
                quantity: configurations.left.quantity
            });
        }
        if (queries.right.sku && configurator.right.isEnabled) {
            deliveryItems.push({
                sku: queries.right.sku,
                quantity: configurations.right.quantity
            });
        }
    }
    return Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        showLoader: isLoading,
        deliveryItems: deliveryItems,
        isExcludedFromCheckout: activeVariant.isExcludedFromCheckout,
        fallbackLabel: getLabel('products.deliveryIndicator.selectPrescription')
    }) : null;
};

export { CLDeliveryIndicator };
//# sourceMappingURL=CLDeliveryIndicator.js.map
